import { render } from "./TreePanel.vue?vue&type=template&id=651842ad&ts=true"
import script from "./TreePanel.vue?vue&type=script&lang=ts"
export * from "./TreePanel.vue?vue&type=script&lang=ts"

import exportComponent from "/codebuild/output/src4158985207/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__